import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from './appServices/AuthService/auth.service';
import { environment } from 'src/environments/environment';
import { interval } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CrossTabService } from './appServices/CrossTabService/crossTab.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'QMS';
  private inactivityTimeout = environment.InactivityTimeOut * 60 * 1000; // 45 minutes in milliseconds
  private inactivityTimer: any;
  private lastActivityKey = 'lastActivity';

  constructor(private authService: AuthService,private router: Router,private crossTabService: CrossTabService) {}

  ngOnInit() {
    this.resetInactivityTimer();
    this.setupStorageListener();
    interval(60000).subscribe(() => {
      if(!this.router.url.includes('Login') && !this.router.url.includes('LogOut')){
        this.authService.refreshToken();
      }
    });
    let isNotLoginOrLogout:any;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        isNotLoginOrLogout = !event.urlAfterRedirects.includes('Login') && !event.urlAfterRedirects.includes('LogOut');
      }
    });
    this.crossTabService.onMessage((msg:any) => {
      if ((msg.action === 'refresh' && isNotLoginOrLogout)) {
        window.location.reload();
      }
    });
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  handleUserActivity() {
    this.updateLastActivityTime();
    this.resetInactivityTimer();
  }

  private resetInactivityTimer(): void {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(() => {
      this.authService.logout();
    }, this.inactivityTimeout);
  }

  private updateLastActivityTime(): void {
    localStorage.setItem(this.lastActivityKey, Date.now().toString());
  }
  private getLastActivityTime(): number | null {
    const lastActivity = localStorage.getItem(this.lastActivityKey);
    return lastActivity ? parseInt(lastActivity, 10) : null;
  }
  private setupStorageListener(): void {
    window.addEventListener('storage', (event) => {
      if (event.key === this.lastActivityKey) {
        const lastActivityTime = this.getLastActivityTime();
        if (lastActivityTime) {
          const currentTime = Date.now();
          const elapsedTime = currentTime - lastActivityTime;

          if (elapsedTime < this.inactivityTimeout) {
            // User was active in another tab, reset the timer
            this.resetInactivityTimer();
          } else {
            // Handle user inactivity (e.g., logout or show a message)
            console.log('User inactive for 45 minutes');
          }
        }
      }
    });
  }
}
